import { Component, ChangeDetectionStrategy, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IconComponent } from "@rig/ng-media";
import { AssetUrlModule } from "../../pipes/asset-url/asset-url.module";

@Component({
  selector: "static-header",
  templateUrl: "./static-header.component.html",
  styleUrls: ["./static-header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, IconComponent, AssetUrlModule]
})
export class StaticHeaderComponent {
  @Input() logo = "rbc_shield-text_ondark_en";
  enToggle = true;
}
